import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex flex-col h-full overflow-hidden" };
const _hoisted_2 = {
    key: 0,
    class: "flex justify-center py-8"
};
const _hoisted_3 = {
    key: 1,
    class: "flex flex-col items-center justify-center flex-1 px-4 py-8 text-center"
};
const _hoisted_4 = { class: "text-sm text-gray-400" };
const _hoisted_5 = {
    key: 2,
    class: "flex-1 overflow-y-auto"
};
import { IconInbox } from "@tabler/icons-vue";
import { useI18n } from "vue-i18n";
import ConversationListItem from "./ConversationListItem.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ConversationList',
    props: {
        conversations: {},
        activeConversationId: {},
        isLoading: { type: Boolean },
        currentUserId: {}
    },
    emits: ["select"],
    setup(__props) {
        const { t } = useI18n();
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.isLoading && !__props.conversations.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("div", { class: "w-5 h-5 border-2 rounded-full border-eorange-400 border-t-transparent animate-spin" }, null, -1)
                        ]))]))
                    : (!__props.conversations.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_unref(IconInbox), { class: "w-8 h-8 mb-2 text-gray-300" }),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("conversation.list.empty")), 1)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.conversations, (conv) => {
                                return (_openBlock(), _createBlock(ConversationListItem, {
                                    key: conv.id,
                                    conversation: conv,
                                    "active-conversation-id": __props.activeConversationId,
                                    "current-user-id": __props.currentUserId,
                                    onSelect: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('select', $event)))
                                }, null, 8, ["conversation", "active-conversation-id", "current-user-id"]));
                            }), 128))
                        ]))
            ]));
        };
    }
});
